import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSONWith} from '../../platform/functional-fetch-wrapper'
import type {
  AutoAssignAgentConfigurationResponse,
  CreateAutoAssignAgentConfigurationRequest,
  DestroyAutoAssignAgentConfigurationRequest,
  UpdateAutoAssignAgentConfigurationRequest,
} from './contracts'

export async function apiCreateAutoAssignAgentConfiguration(
  body: CreateAutoAssignAgentConfigurationRequest,
): Promise<AutoAssignAgentConfigurationResponse> {
  const apiData = getApiMetadata('memex-autopilot-configuration-create-api-data')
  const {data} = await fetchJSONWith<AutoAssignAgentConfigurationResponse>(apiData.url, {
    method: 'POST',
    body,
  })
  return data
}

export async function apiUpdateAutoAssignAgentConfiguration(
  body: UpdateAutoAssignAgentConfigurationRequest,
): Promise<AutoAssignAgentConfigurationResponse> {
  const apiData = getApiMetadata('memex-autopilot-configuration-update-api-data')
  const {data} = await fetchJSONWith<AutoAssignAgentConfigurationResponse>(apiData.url, {
    method: 'PUT',
    body,
  })
  return data
}

export async function apiDestroyAutoAssignAgentConfiguration(
  body: DestroyAutoAssignAgentConfigurationRequest,
): Promise<void> {
  const apiData = getApiMetadata('memex-autopilot-configuration-destroy-api-data')
  await fetchJSONWith<void>(apiData.url, {
    method: 'DELETE',
    body,
  })
}
